import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useMainContext } from "../../../Context";
import { ShowContactData, single, storeMark, toggleMark } from "../../../Utils/Apis";

export const useSingle = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [markLoading, setMarkLoading] = useState(false);
  const navigate = useNavigate();
  const { slug } = useParams();
  const { post, isLogin } = useMainContext();
  const [form, setForm] = useState({ show: false });
  const [contactLoading, setContactLoading] = useState(true);

  const get = async () => {
    setLoading(true);
    const { data } = await post(single, {
      slug,
    });
    setData(data);
    setLoading(false);
  };
  const toggle = async () => {
    setMarkLoading(true);
    const { status } = await post(toggleMark, { ads_id: data?.ads?.id });
    if (+status == 200) {
      setData({ ...data, mark: data.mark == "true" ? "false" : "true" });
    }
    setMarkLoading(false);
  };

  const getContactData = async () => {
    setContactLoading(true);
    const { data } = await post(ShowContactData, { slug });
    setContactLoading(false);
  };

  const handler = () => {
    if (isLogin()) {
      getContactData();
      setForm({ ...form, show: true });
    } else {
      toast.error("برای مشاهده ابتدا ثبت نام کنید");
    }
  };

  useEffect(() => {
    get();
  }, []);

  return {
    data,
    loading,
    toggle,
    markLoading,
    navigate,
    handler,
    form,
    setForm,
    contactLoading
  };
};

export const useContactData = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({ show: false });
  const { slug } = useParams();
  const { post, isLogin } = useMainContext();

  const get = async () => {
    setLoading(true);
    const { data } = await post(ShowContactData, { slug });
    console.log("------------------ss  " + ShowContactData);
    setData(data);
    setLoading(false);
  };

  useEffect(() => {
    get();
  }, [slug]);

  return {
    data,
    loading,
    form,
    setForm,
  };
};
